import { Table, TableProps } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import { getTableConfig } from './config';
import {
  Actions,
  AppArea,
  LmsCertificate,
  Subjects,
} from 'src/graphql/generated/graphql';
import { useCan } from 'src/utils/can';

type LmsCertificatesTableProps = Omit<TableProps, 'columns'> & {
  className?: string;
  data: LmsCertificate[];
};

export const LmsCertificatesTable = ({
  data,
  className,
  options,
  ...props
}: LmsCertificatesTableProps) => {
  const { t } = useTranslation();
  const { can } = useCan();

  const canWrite = can({
    action: Actions.Write,
    appArea: AppArea.Lms,
    subject: Subjects.Certificates,
  });
  const canDelete = can({
    action: Actions.Delete,
    appArea: AppArea.Lms,
    subject: Subjects.Certificates,
  });

  const tableConfig = getTableConfig(data, { t, canWrite, canDelete });

  return (
    <div className={className}>
      <Table options={options} {...props} data={data} columns={tableConfig} />
    </div>
  );
};
